import { useSelector } from 'react-redux'

import type { RootState } from '../../store/reducers'

import { KebabMenuButton } from './KebabMenuButton'

interface KebabMenuProps {
	clientId?: number
}

export const KebabMenu = ({ clientId }: KebabMenuProps): JSX.Element => {
	const applicantId = useSelector(
		(state: RootState) => state.authentication.applicantId,
	)

	return <KebabMenuButton applicantId={applicantId} clientId={clientId} />
}
